import React from "react";
import config from "config";
import DetailDropDown from "./detailDropDown/DetailDropDown";
import { DetailProps } from "./detailDropDown/detail/Detail";

function Calendar() {
  const details: Array<DetailProps> = config.calendarDetails.map((event) => {
    return {
      title: event.date,
      detail: event.details,
    };
  });

  return <DetailDropDown title="CALENDAR" details={details} />;
}

export default Calendar;
